/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { createRoute } from '@gh/builder-shared';
import { SmsListComponent } from './components/sms-list/sms-list.component';
import { SmsListBusinessService } from './resources';

const routes: Routes = [createRoute({
  path: '',
  component: SmsListComponent,
  init: SmsListBusinessService,
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderSmsRoutingModule {
}
